/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const SelectContainer = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.SelectContainer {...otherProps} className={className}>
      {children}
    </components.SelectContainer>
  );
};

SelectContainer.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

SelectContainer.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default SelectContainer;
